// extracted by mini-css-extract-plugin
module.exports = {"section":"_93444fe79c--section--2Fpjn","list":"_93444fe79c--list--14MT3","column":"_93444fe79c--column--3pfvy"};